import request from '~/utils/http';
// 深圳送货地址
export function addShippingAddress(sendData) {
  return request({
    url: 'api/ShippingAddress/Add',
    method: 'post',
    data: sendData
  })
}


export function getShippingAddressList(sendData) {
  return request({
    url: 'api/ShippingAddress/GetList',
    method: 'post',
    data: sendData
  })
}
